module.exports = __webpack_public_path__ + "img/no-wifi.0220bed9.svg";